import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ExpansionPanel from '@material-ui/core/ExpansionPanel'
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary'
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails'
import InfoIcon from '@material-ui/icons/Info'
import { readFooter } from 'actions/template'
import language from 'utils/vast-languagepack'

const createMarkup = (footer) => {
  return { __html: footer }
}

export default connect(
  (state) => ({ footer: state.email.footerValue }),
  (dispatch) => bindActionCreators({ readFooter }, dispatch),
)(
  class Footer extends Component {
    componentDidMount() {
      this.props.readFooter()
    }

    render() {
      const { footer } = this.props
      return (
				<div
					style={{
						width: '100%',
						margin: 'auto',
						borderBottomLeftRadius: 24,
						borderBottomRightRadius: 24,
					}}
				>
					<ExpansionPanel
						style={{
							// borderRight: '1px solid rgba(0,0,0,.08)',
							// borderLeft: '1px solid rgba(0,0,0,.08)',
							// borderBottom: '1px solid rgba(0,0,0,.08)',
							borderRadius: 0,
							boxShadow: '0px 0px',
							// borderBottomLeftRadius: 35,
							// borderBottomRightRadius: 35,
							overflow: 'hidden',
							backgroundColor: '#ffffff',
						}}
					>
						<ExpansionPanelSummary
							style={{ width: '100%' }}
							expandIcon={<InfoIcon />}
						>
							<div
								style={{ width: '100%' }}
								dangerouslySetInnerHTML={createMarkup(footer)}
							/>
						</ExpansionPanelSummary>
						<ExpansionPanelDetails>
							<p style={{ fontSize: '11px' }}>
								{language.task.add.emailFooter.notice1}{' '}
								<a href="https://www.ftc.gov/tips-advice/business-center/guidance/can-spam-act-compliance-guide-business">
									{language.task.add.emailFooter.canSpam}
								</a>
								{language.task.add.emailFooter.notice2}{' '}
								<a href="https://en.wikipedia.org/wiki/Terms_of_service">
									{language.task.add.emailFooter.termsService}
								</a>
							</p>
						</ExpansionPanelDetails>
					</ExpansionPanel>
				</div>
			)
    }
  },
)
